export const enums = {
  QUANTITY_TYPE: Object.freeze({
    CTN: "ctn",
    PIECE: "piece",
  }),
  PRICE_TYPE: Object.freeze({
    NET_DISCOUNT: "net_discount",
    ADD_DISCOUNT: "additional_discount",
    NET_PRICE: "net_price",
    NET_PRICE_PIECE: "net_price_piece",
    NET_PRICE_CTN: "net_price_ctn",
  }),
  PRICE_BOOK_TYPE: Object.freeze({
    MRP: "mrp",
    COMPANY_RATE: "company_rate",
  }),
  ADDRESS_TYPE: Object.freeze({
    BILLING: "billing",
    SHIPPING: "shipping",
    HEADQUARTER: "headquarter",
  }),

  PRODUCT_STATUS: Object.freeze({
    BLOCKED: "blocked",
    DISCONTINUED: "discontinued",
  }),
  COMPANY_RATE_TYPE: Object.freeze({
    RATE: "rate",
    DISCOUNT: "discount",
  }),
  ORDER_STATUS_TYPE: Object.freeze({
    IN_EXECUTION: "in_execution",
    IN_DISPATCH: "in_dispatch",
    COMPLETED: "completed",
    IN_REVIEW: "in_review",
    IN_PROGRESS: "in progress",
    CREDIT_NOTE: "credit note"
  }),
  ORDER_TYPE: Object.freeze({
    SALES: "sale_order",
    PURCHASE: "purchase_order",
    CREDIT_NOTE: "credit_note",
    PURCHASE_INVOICE: "purchase_invoice",   
  }),
  ACTION_TYPE: Object.freeze({
    MULTI_SELECT: "multi_select",
    SINGLE_SELECT: "single_select",
  }),
  INVOICE_TYPE: Object.freeze({
    SALE: "sale",
    PURCHASE : "purchase"
  }),
  CLIENT_TYPE: Object.freeze({
    SUPPLIER: "supplier",
    BUYER: "buyer",
  }),
  INVOICE_STATUS_TYPE: Object.freeze({
    DRAFT: "draft",
    IN_REVIEW: "in_review",
    COMPLETED: "completed"
  }),
};
